<div *ngIf="global_texts" class="all-content">
  <div class="">
    <app-header></app-header>
  </div>
  <div class="content">
    <div class="inner-content">

      <div class="sidebar-content">
        <app-sidebar></app-sidebar>
      </div>

      <div>
        <div class="mt-5 mt-md-3 p-3 p-lg-5">
          <div class="d-flex">

            <div class="self-module mod-end" *ngIf="stats_texts">

              <!-- Bubble Title -->
              <div class="bubble-step right mb-5">
                <div class="d-flex flex-column flex-lg-row align-items-center gap-3">
                  <div class="flex-fill bloc-img-end" *ngIf="stats_texts.image">
                    <img [src]="stats_texts?.image" /></div>
                  <div class="flex-fill">
                    <!-- Title -->
                    <h1 class="d-block fw-bold color-green py-3 text-uppercase"
                        [innerHtml]="stats_texts.title"></h1>

                    <!-- Text -->
                    <h3 [innerHtml]="stats_texts.text"></h3>
                  </div>
                </div>

                <!--Annexes -->
                <div *ngIf="current_screen_annexes">
                  <app-annexes [annexes]="current_screen_annexes" [class]="current_screen_special_class!"></app-annexes>
                </div>

                <!-- Stars -->
                <div *ngIf="has_stars" class="star-rating mt-5">
                  <span *ngFor="let star of stars; let i = index">
                    <span *ngIf="(i+1) <= note; else emptyStar" class="icon material-icons color-green">star</span>
                    <ng-template #emptyStar><span class="icon material-symbols-outlined">star</span></ng-template>
                   </span>
                </div>

                <div>
                  <!-- Button -->
                  <div class="mt-5 mx-auto text-center">
                    <button class="btn btn-solid-green text-uppercase mx-3"
                            (click)="app.sharedHelper.goToNextScreen()"
                            [innerHtml]="global_texts.continue">
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <app-footer></app-footer>
    </div>
  </div>
</div>
